import React from 'react';
import styled from 'styled-components';

import { ListItem } from './ListItem';

export const ListList = ({ storeName, listId, count, time }) => {
  return (
    <ListWrapper>
      <ListItem
        storeName={storeName}
        listId={listId}
        count={count}
        time={time}
      />
    </ListWrapper>
  );
};

const ListWrapper = styled.ul`
  list-style-type: none;
  padding: 0;
`;
